export default __webpack_public_path__ + "locales/sk/OAuth.json?hash=35712479bd9a80544b6ebee5436fbba9";